import React, { useState } from 'react';
import initialData from '../../data/initialData';
import { Column } from '../BoardElements';
import styled from '@emotion/styled';
import PlusButton from '../PlusButton';
import { DragDropContext, DropResult, Droppable } from 'react-beautiful-dnd';

const AddColumnButton = styled.button`
  display: flex;
  padding: 16px;
  gap: 16px;
  width: 272px;
  min-width: 272px;
  border-radius: 16px;
  background-color: ${props => props.theme.colors.gray + '0D'};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  height: fit-content;
  align-items: center;
`;

const Container = styled.div`
  display:flex;
  // Make it scrollable horizontally
  overflow-x: auto;
  overflow-y: hidden;
  height:100%;
  align-items: stretch;
  flex: 1;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  padding-bottom: 16px;
`;

export default function Board() {
  const [data, setData] = useState(initialData);
  const onDragEnd = (result: DropResult) => {
    const { destination, source, draggableId, type } = result;
    if (!destination) return;
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    if (type === 'column') {
      const newColumnOrder = Array.from(data.columnOrder);
      newColumnOrder.splice(source.index, 1);
      newColumnOrder.splice(destination.index, 0, draggableId);

      const newState = {
        ...data,
        columnOrder: newColumnOrder,
      };

      setData(newState);
      return;
    }

    const start = data.columns[source.droppableId];
    const finish = data.columns[destination.droppableId];

    if (start === finish) {
      const column = data.columns[source.droppableId];
      const newTaskIds = Array.from(column.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...column,
        taskIds: newTaskIds,
      };

      const newState = {
        ...data,
        columns: {
          ...data.columns,
          [newColumn.id]: newColumn,
        },
      };

      setData(newState);
    } else {
      const startTaskIds = Array.from(start.taskIds);
      startTaskIds.splice(source.index, 1);
      const newStart = {
        ...start,
        taskIds: startTaskIds,
      };

      const finishTaskIds = Array.from(finish.taskIds);
      finishTaskIds.splice(destination.index, 0, draggableId);
      const newFinish = {
        ...finish,
        taskIds: finishTaskIds,
      };

      const newState = {
        ...data,
        columns: {
          ...data.columns,
          [newStart.id]: newStart,
          [newFinish.id]: newFinish,
        },
      };

      setData(newState);
    }
  };

  return (
    <div className='planner-board-wrapper'>
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='all-columns' direction='horizontal' type='column'>
        {
          (provided) => (
            <Container className='u-fancy-scrollbar' {...provided.droppableProps} ref={provided.innerRef}>
              {data.columnOrder.map((columnId, index) => {
                const column = data.columns[columnId];
                const tasks = column.taskIds.map((taskId) => data.tasks[taskId]);
                return (
                  <Column key={column.id} column={column} tasks={tasks} columnIndex={index} />
                );
              })}
              {provided.placeholder}
              <Droppable droppableId='add-column' isDropDisabled={true} >
                {(providedButton) => (
                  <AddColumnButton {...providedButton.droppableProps} ref={providedButton.innerRef}>
                    <PlusButton />
                    <span className='planner-text'>Додати колонку</span>
                  </AddColumnButton>
                )  
                }
              </Droppable>
            </Container>
          )
        }
      </Droppable>
    </DragDropContext>
    </div>
  );
}